import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Khong tim thay phan tu #root trong index.html');
}

// StrictMode chay effect hai lan o che do phat trien. Do la co y: no lo ra
// nhung effect khong don dep dung cach - dung thu ta CAN bat som trong mot
// trinh xem PDF, noi moi lan quen huy tac vu render deu la mot ro ri bo nho.
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
